import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Button from "../../components/Button/Button";
import ConfirmationPopup from "../../components/ConfirmationPopap/ConfirmationPopap";
import Header from "../../components/Header/Header";
import {CurrentUserContext} from "../../contexts/CurrentUserContext";
import useFormValidator from "../../hooks/useFormValidator";
import "./ProfilePage.css";

function Profile({isLoggedIn, handleLogoutUser, handleUpdateUser, handleDeleteUser, profileError}) {
  const [isChanged, setIsChanged] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState(null);

  const currentUser = useContext(CurrentUserContext);
  const validation = useFormValidator();
  const navigate = useNavigate();

  const isFormValid = validation.isValid && (validation.values.name !== currentUser.name || validation.values.email !== currentUser.email);

  useEffect(() => {
    validation.setCurrentUserValues(currentUser);
  }, [currentUser]);

  function handleEdit(evt) {
    evt.preventDefault();
    setIsChanged(true);
  }

  function handleCancel(evt) {
    evt.preventDefault();
    if (validation.resetForm) {
      validation.resetForm(currentUser);
    } else {
      validation.setCurrentUserValues(currentUser);
    }
    setIsChanged(false);
  }

  function handleSubmit(evt) {
    evt.preventDefault();
    handleUpdateUser(validation.values);
    setIsChanged(false);
  }

  function handleLogout(evt) {
    evt.preventDefault();
    setPopupType("logout");
    setIsPopupOpen(true);
  }

  function handleDeleteClick(evt) {
    evt.preventDefault();
    setPopupType("delete");
    setIsPopupOpen(true);
  }

  function onConfirmPopup() {
    if (popupType === "logout") {
      handleLogoutUser();
      navigate("/");
    } else if (popupType === "delete") {
      handleDeleteUser();
    }
    setIsPopupOpen(false);
    setPopupType(null);
  }

  function onClosePopup() {
    setIsPopupOpen(false);
    setPopupType(null);
  }

  return (
    <div className="profile-page">
      <Header isLoggedIn={isLoggedIn} />
      <section className="profile">
        <h1 className="profile__title">Привет, {currentUser.name}!</h1>
        <form className="profile__form" onSubmit={handleSubmit}>
          <label className="profile__form-input-label" htmlFor="profile-name">
            Имя
          </label>
          <input
            className="profile__form-input"
            id="name"
            name="name"
            type="text"
            value={validation.values.name ?? currentUser.name ?? ""}
            onChange={(e) => validation.handleChange(e)}
            minLength="2"
            disabled={!isChanged}
            required
            label="E-mail"
          />
          <label className="profile__form-input-label" htmlFor="profile-email">
            E-mail
          </label>
          <input
            className="profile__form-input"
            id="email"
            name="email"
            type="email"
            value={validation.values.email ?? currentUser.email ?? ""}
            onChange={(e) => validation.handleChange(e)}
            minLength="2"
            disabled={!isChanged}
            required
          />
          <span className="profile__error">{[profileError, validation.errors.name, validation.errors.email].find(Boolean)}</span>
          <div className="profile__buttons-select">
            {!isChanged ? (
              <Button buttonId="profile__button-edit" buttonName="Редактировать аккаунт" additionalClass="profile__button-edit" onClick={handleEdit} />
            ) : (
              <>
                <Button
                  buttonId="profile__button-save"
                  buttonName="Сохранить"
                  additionalClass={`profile__button-save ${isFormValid ? "button_active" : ""}`}
                  type="submit"
                  disabled={!isFormValid}
                />
                <Button buttonId="profile__button-cancel" buttonName="Отмена" additionalClass="profile__button-cancel" onClick={handleCancel} type="button" />
              </>
            )}
          </div>
          <Button buttonId="profile__button-logout" buttonName="Выйти из аккаунта" additionalClass="profile__button-logout" onClick={handleLogout} />
          {/* <Button buttonId="profile__button-delete" buttonName="Удалить аккаунт" additionalClass="profile__button-delete" onClick={handleDeleteClick} /> */}
        </form>
      </section>
      <ConfirmationPopup type={popupType} isActive={isPopupOpen} onConfirm={onConfirmPopup} onClose={onClosePopup} />
    </div>
  );
}

export default Profile;
